import { Configuration } from '@linktivity/tata';
import { getAccessToken, refreshAccessToken } from './session';

const BASE_PATH = import.meta.env.VITE_TATA_API_BASE_URL as string;

const UNAUTHORIZED = 401;

const buildRequestHeaders = (headers?: HeadersInit) => {
  const requestHeaders = new Headers(headers ?? {});
  requestHeaders.set('Content-Type', 'application/json');
  requestHeaders.set('grpc-metadata-agent', 'triplabo');

  const accessToken = getAccessToken();
  if (accessToken) {
    requestHeaders.set('grpc-metadata-authorization', accessToken);
  }
  return requestHeaders;
};

const readResponseData = async (
  response: Response
): Promise<Record<string, unknown> | null> => {
  const data = await response
    .clone()
    .json()
    .catch(() => null);
  return data && typeof data === 'object'
    ? (data as Record<string, unknown>)
    : null;
};

const config = new Configuration({
  basePath: BASE_PATH,
  middleware: [
    {
      pre: async context => {
        context.init.headers = buildRequestHeaders(context.init.headers);
      },
      post: async context => {
        if (context.response.ok) {
          return;
        }
        const data = await readResponseData(context.response);
        const init = context.init as RequestInit & { retried?: boolean };

        // Unauthorized: refresh the access token, then retry once.
        // context.fetch re-runs the pre middleware, which rebuilds the
        // headers from the freshly stored token.
        if (context.response.status === UNAUTHORIZED && !init.retried) {
          const accessToken = await refreshAccessToken();
          if (accessToken) {
            init.retried = true;
            return context.fetch(context.url, context.init);
          }
        }

        console.error(
          data?.error_description || data?.error_message || data?.error_code
        );
      }
    }
  ]
});

export default config;
